import { format, isAfter, isEqual, isValid } from 'date-fns';

export const getVariantImageSize = (variant: 'mobile' | 'small' | 'medium' | 'large') => {
  switch (variant) {
    case 'mobile':
      return 120;
    case 'small':
      return 160;
    case 'medium':
      return 200;
    case 'large':
      return 220;
    default:
      return 220;
  }
};

export const isExpired = (date?: Date): boolean => {
  if (!date) return false;
  const expiryDate = new Date(date);
  expiryDate.setDate(expiryDate.getDate() + 1);
  expiryDate.setHours(0, 0, 0, 0);
  const now = new Date();
  return !isAfter(expiryDate, now) && !isEqual(expiryDate, now);
};

export const formatDate = (date?: Date, hideYear?: boolean): string | undefined => {
  if (!date || !isValid(date)) {
    return undefined;
  }
  if (hideYear) {
    return format(date, 'd MMMM');
  }
  return format(date, 'd MMMM yyyy');
};
